import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Livesharelist = Loadable(lazy(() => import('./Livesharelist')));

const LiveshareRoutes = [
	{
		path: '/liveshare',
		element: <Livesharelist />,
		auth: authRoles.admin,
	},
];

export default LiveshareRoutes;
